import { createFileRoute } from '@tanstack/react-router'
import { UserDetailPage } from '../../../components/AdminUsers/UserDetail'

export const Route = createFileRoute('/admin/users/$id')({
  component: AdminUserDetailRoute,
})

function AdminUserDetailRoute() {
  const { id } = Route.useParams()
  return <UserDetailPage id={id} />
}
